// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReservationContainer-panelHeader-OfrjV {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  border-bottom: 1px solid var(--primary-border);
  background: var(--background-primary);
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.ReservationContainer-listFlex-nNKVL {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  margin: 30px 0;
}

.ReservationContainer-formControlInput-AXvmI {
  width: 382px;
  height: 45px;
  border: 1px solid var(--primary-border);
  border-radius: 23px;
}

.ReservationContainer-linkCss-Aw2yR {
  padding: 12px 20px !important;
  border-radius: 23px !important;
}

.ReservationContainer-plusIcon-WKq2o {
  margin-right: 6px;
}

.ReservationContainer-noMargin-PmD1b {
  margin: 0;
}

@media screen and (max-width: 767px) {
  .ReservationContainer-formControlInput-AXvmI {
    width: 100%;
    margin-bottom: 15px;
  }

  .ReservationContainer-listFlex-nNKVL {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-top: 15px;
    margin-bottom: 15px;
    row-gap: 15px;
  }

  .ReservationContainer-mobileSearchWidth-QWqOC {
    width: 100%;
  }

  .ReservationContainer-linkCss-Aw2yR {
    display: block;
    text-align: center;
  }

}`, "",{"version":3,"sources":["webpack://./src/routes/reservation/ReservationContainer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,mBAAe;QAAf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;AAEF","sourcesContent":[".panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  border-bottom: 1px solid var(--primary-border);\n  background: var(--background-primary);\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.listFlex {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 30px 0;\n}\n\n.formControlInput {\n  width: 382px;\n  height: 45px;\n  border: 1px solid var(--primary-border);\n  border-radius: 23px;\n}\n\n.linkCss {\n  padding: 12px 20px !important;\n  border-radius: 23px !important;\n}\n\n.plusIcon {\n  margin-right: 6px;\n}\n\n.noMargin {\n  margin: 0;\n}\n\n@media screen and (max-width: 767px) {\n  .formControlInput {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n\n  .listFlex {\n    flex-wrap: wrap;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    row-gap: 15px;\n  }\n\n  .mobileSearchWidth {\n    width: 100%;\n  }\n\n  .linkCss {\n    display: block;\n    text-align: center;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelHeader": `ReservationContainer-panelHeader-OfrjV`,
	"listFlex": `ReservationContainer-listFlex-nNKVL`,
	"formControlInput": `ReservationContainer-formControlInput-AXvmI`,
	"linkCss": `ReservationContainer-linkCss-Aw2yR`,
	"plusIcon": `ReservationContainer-plusIcon-WKq2o`,
	"noMargin": `ReservationContainer-noMargin-PmD1b`,
	"mobileSearchWidth": `ReservationContainer-mobileSearchWidth-QWqOC`
};
module.exports = ___CSS_LOADER_EXPORT___;
